export const GETALL_PAYSCHEMES_LIST = "getAll_payscheme_list"; 
export const GETALL_PAYSCHEMES_LIST_SUCCESSFULL = "getAll_payscheme_list_successfull";